<div class="flex flex-col" [class.bg-body-category]="isMilano">

  <div class="relative">
    <div class="absolute inset-0 -z-10" [class.bg-body-category]="isMilano"></div>

    @if (sortedData(); as promos) {
    @if (promos.length > 0) {
    <div class="px-4 flex flex-col gap-3 pt-4 pb-2 md:px-8 lg:px-12 w-full max-w-8xl md:hidden">

      <div class="flex items-center justify-between">
        <div class="flex items-center gap-2">
          <span class="title text-[30px] md:text-[40px]" [class.text-primary]="isMilano" [class.text-dark]="!isMilano">Nos</span>
          <span class="title text-[30px] md:text-[40px]" [class.text-white]="isMilano" [class.text-dark]="!isMilano">Promos</span>
        </div>
      </div>

      <div class="relative group">
        <div #scrollContainer
             class="scroll-container flex gap-6 overflow-x-auto scrollbar-hide snap-x">
          @for (card of promos; track trackById(card)) {
          @if (card.slug) {
          <a [href]="'/nos-promos' + card.slug"
             draggable="false"
             class="relative flex-shrink-0 rounded-[20px] w-[270px] sm:w-[324px] min-h-[150px] overflow-hidden cursor-pointer flex flex-col snap-center border border-white/10"
             [ngStyle]="{
                        'background-image': 'url(/assets/images/background-promos.webp)',
                        'background-size': 'cover',
                        'background-position': 'center',
                        'background-repeat': 'no-repeat'
                     }"
             (click)="$event.preventDefault(); (!isOrderOffer(card) && card._isAvailable) && openDialogForPromo(card)"
             [class.is-disabled]="isOrderOffer(card) || !card._isAvailable">

            <div class="absolute inset-0 bg-gradient-to-tr from-black/20 to-transparent pointer-events-none"></div>

            @if (isOrderOffer(card) || !card._isAvailable) {
            <div class="absolute inset-0 backdrop-blur-[1px] bg-white/10 z-30 rounded-[20px] pointer-events-none"></div>
            }
            @if (card._availabilityLabel) {
            <div class="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 z-40
              bg-[#ffffffb8] text-badge text-[#000000] font-bold px-3 py-2 rounded-xl shadow-md uppercase
               text-center custom-phone-badge border border-gray-300">
            {{ card._availabilityLabel }}
            </div>
            }
            @if (getPrimaryBadge(card.payload?.activatedFor); as badge) {
            <div class="absolute top-[45px] left-0 z-20 transform -rotate-35 -translate-x-8 -translate-y-8">
              <div class="bg-secondary text-[#FFFFFF] text-[10px] font-bold tracking-wider px-10 py-1 shadow-md border-b border-white/10">
            {{ badge.label }}
            </div>
          </div>
            }

            <div class="relative z-10 flex flex-wrap justify-center gap-3 mt-6 px-3">
              @for (type of card.orderTypes; track type) {
              <span class="bg-[#FFFFFF]/20 backdrop-blur-md border border-[#FFFFFF]/30 text-[#FFFFFF] text-[11px] font-bold px-3 py-1 rounded-[6px] uppercase shadow-sm">
              {{ type }}
              </span>
              }
            </div>

            <div class="relative p-5 h-full flex flex-col justify-end overflow-hidden">
              <div class="relative z-10">
                <p class="text-sm font-black text-[#FFFFFF] leading-[1.2] drop-shadow-lg italic line-clamp-3">
                  {{ card.title }}
                </p>
              </div>
            </div>
          </a>
          }
          }
        </div>
      </div>

    </div>
    }
    }

    <div class="relative flex flex-col gap-3 pt-0 md:pt-8">
      @if (dataPromos(); as promos) {
      @if (promos.length > 0) {
      <div class="w-full py-4 md:py-8 overflow-hidden content relative">
        <div class="py-4 overflow-hidden shadow-lg bg-gradient-to-r from-primary to-primary-dark">
          <div class="inline-flex items-center whitespace-nowrap marquee-animation">
            @for (copy of getRepeatArray(dataPromos()); track copy) {
            @for (promo of dataPromos(); track promo) {
            <span class="text-3xl font-black outline-text uppercase mx-8" [class.text-white]="isMilano" [class.text-dark]="!isMilano">
                      {{ promo.title }}
                    </span>
            <mat-icon class="mx-6 text-white scale-150">star</mat-icon>
            }
            }
          </div>
        </div>
      </div>
      }
      }

      <div class="px-4 md:px-8 lg:px-12 w-full max-w-8xl">
        <h2 class="title text-[28px] sm:text-[40px] text-center whitespace-normal break-words leading-tight mb-8">
          <span [class.text-primary]="isMilano" [class.text-dark]="!isMilano">Notre</span>
          <span [class.text-white]="isMilano" [class.text-base-content]="!isMilano"> Sélection</span>
          <span [class.text-primary]="isMilano" [class.text-dark]="!isMilano"> Gourmande</span>
        </h2>

        <div class="columns-2 md:columns-3 lg:columns-3 xl:columns-4 2xl:columns-5 gap-4">
          @for (card of data(); track card; let i = $index) {
          <div class="break-inside-avoid mb-4">
            @if (card.products !== 0) {

          @if (isMilano) {
          <div class="relative rounded-lg overflow-hidden transition-all duration-300 group"
               style="border: 1px solid rgba(255, 247, 236, 0.57);"
               [ngClass]="getCardClass(i)">
            <div class="relative w-full aspect-square">
  <img
    [ngSrc]="card.image"
    [alt]="card.name"
    fill
    loading="lazy"
    sizes="(max-width: 640px) 50vw,
           (max-width: 1024px) 33vw,
           25vw"
    class="object-contain"
  />
</div>
            <div class="p-3 md:p-4 content-footer">
              <div class="flex justify-between items-center gap-2">
                <div class="flex-1 min-w-0">
                  <h3 class="text-[20px] sm:text-[28px] md:text-[32px] text-[#FFB936] font-['Katibeh',cursive] mb-1 truncate">
          {{ card.name }}
          </h3>
          <span class="text-white font-['Katibeh',cursive] text-[14px] sm:text-[18px] md:text-[20px]">
          {{ card.products }} Produits
                          </span>
                        </div>
                        <a
                        [routerLink]="['/product/category', card.slug]"
                           class="w-8 h-8 sm:w-10 sm:h-10 bg-secondary/20 border border-secondary
                            flex justify-center items-center rounded cursor-pointer transition-all
                            duration-300 flex-shrink-0 text-secondary"
                           (click)="$event.preventDefault(); openDialog(card.id, card.slug)">
                          <mat-icon class="material-symbols-outlined text-[18px] sm:text-[24px]">shopping_cart</mat-icon>
                        </a>
                      </div>
                    </div>
                  </div>
          }

          @else {
          <div class="custom-menu-card relative rounded-lg overflow-hidden border border-gray-100 bg-white shadow-sm hover:shadow-md transition-shadow">
            <div class="card-overlay absolute inset-0 pointer-events-none"></div>
 <div class="relative w-full aspect-square">
  <img
    [ngSrc]="card.image"
    [alt]="card.name"
    fill
    loading="lazy"
    sizes="(max-width: 640px) 50vw,
           (max-width: 1024px) 33vw,
           25vw"
    class="object-contain"
  />
</div>
            <div class="p-3 flex justify-between items-center card-text-section">
              <div class="flex-1">
                <h3 class="text-[24px] text-dark font-secondary leading-none">
          {{ card.name }}
          </h3>
          <span class="text-gray-400 text-[14px]">
          {{ card.products }} Produits
                        </span>
                      </div>
                      <a [routerLink]="['/product/category', card.slug]"
                         class="w-10 h-10 bg-primary text-white flex justify-center items-center rounded-full cursor-pointer"
                         (click)="$event.preventDefault(); openDialog(card.id, card.slug)">
                        <mat-icon class="text-[20px] flex items-center justify-center">shopping_cart</mat-icon>
                      </a>
                    </div>
                  </div>
          }

          }
          </div>
          }
        </div>
      </div>

      <div class="overflow-hidden w-full">
        <div class="marquee-container py-8 md:py-12">
          <div class="marquee-content flex items-center">
            @for (copy of [0, 1, 2, 3]; track copy) {
            @for (item of marqueeItems; track item) {
            <mat-icon class="mx-4 text-[#FFB936] scale-125">star</mat-icon>
            <span class="marquee-item"
                  [style.-webkit-text-stroke]="isMilano ? '1.5px #FFFFFF' : '1.5px var(--text-site)'"
                  [style.color]="'transparent'"
                  [style.opacity]="isMilano ? '0.7' : '0.4'">
                  {{ item }}
                </span>
            }
            }
          </div>
        </div>
      </div>

    </div>
  </div>

  <div class="w-full max-w-8xl bg-body-content-category pt-[15px] lg:pt-[40px]">
    <div class="relative flex flex-col md:flex-row lg:flex-row items-start md:items-center lg:items-center justify-between gap-8 px-4 lg:px-8 max-w-7xl mx-auto">

      <div class="flex flex-col gap-3 w-full md:w-1/2 lg:w-auto order-1 lg:flex-1">

        <div class="flex flex-col gap-2 text-center md:text-left lg:text-left order-2 lg:order-3 lg:hidden">
          <h2 class="flex items-center justify-center md:justify-start lg:justify-start gap-2 flex-wrap">
            <span class="text-[30px] leading-none">🍔</span>
            <span class="title text-[30px] md:text-[36px] leading-tight text-dark">Livraison à</span>
            <span class="title text-[30px] md:text-[36px] text-primary leading-tight">Domicile</span>
          </h2>
          <div class="flex flex-col">
            <p class="text text-[20px] font-600 text-dark">Pas envie de sortir ? On comprend.</p>
            <p class="text text-[20px] font-600 text-dark">Commandez, détendez-vous, et laissez-nous faire.</p>
            <p class="text text-[20px] font-600 text-dark">Votre repas arrive pendant que vous restez bien au chaud.</p>
          </div>
          <div class="flex items-center justify-center md:justify-start lg:justify-start gap-4 mb-3">
            <div class="flex justify-center items-center bg-primary/20 border border-primary/30 w-12 h-12 text-primary rounded-full flex-shrink-0">
              <mat-icon>phone</mat-icon>
            </div>
            <div class="flex flex-col">
              <p class="text font-semibold text-dark text-base md:text-lg">Comment commander ?</p>
              @for (phone of phones(); track phone) {
              <div>
                <p class="text text-[20px] font-600 text-dark">Appelez :
                  <a [href]="'tel:' + phone" class="text-primary underline underline-offset-2 transition-colors cursor-pointer font-medium">
              {{ phone }}
              </a>
            </p>
          </div>
              }
            </div>
          </div>
        </div>

        <div class="flex flex-col gap-3 order-1 items-center md:items-stretch">
          <mat-card class="content-card w-[312px] md:w-auto border border-gray-100 shadow-sm">
            <mat-card-content>
              <div class="flex items-center gap-4">
                <div class="flex justify-center items-center bg-primary/20 border border-primary/30 w-14 h-14 text-primary rounded-full flex-shrink-0">
                  <mat-icon>new_releases</mat-icon>
                </div>
                <p class="text text-[#000000FF] text-lg">Certification d'Authenticité</p>
              </div>
            </mat-card-content>
          </mat-card>

          <mat-card class="content-card rounded-[10px] w-[312px] md:w-auto">
            <mat-card-content>
              <div class="flex items-center gap-4">
                <div class="flex justify-center items-center bg-primary/20 border border-primary/30 w-14 h-14 text-primary rounded-full flex-shrink-0">
                  <mat-icon>speed</mat-icon>
                </div>
                <p class="text text-[#000000FF] text-lg">Livraison Express</p>
              </div>
            </mat-card-content>
          </mat-card>

          <mat-card class="content-card rounded-[10px] w-[312px] md:w-auto bg-white border border-gray-100 shadow-sm">
            <mat-card-content>
              <div class="flex items-center gap-4">
                <div class="flex justify-center items-center bg-primary/20 border border-primary/30 w-14 h-14 text-primary rounded-full flex-shrink-0">
                  <mat-icon>security</mat-icon>
                </div>
                <p class="text text-[#000000FF] text-lg">Paiement Securisé</p>
              </div>
            </mat-card-content>
          </mat-card>
        </div>
      </div>

      <div class="relative w-full md:w-1/2 lg:w-auto lg:flex-1 h-[320px] md:h-[432px] flex justify-center order-3 md:order-2 lg:order-2 items-end self-end">
        <img
         S ngSrc="assets/images/img-pizza.webp"
          alt="Pizza"
          fill
          priority
          sizes="(max-width: 768px) 100vw,
           (max-width: 1024px) 50vw,
           33vw"
          class="object-contain drop-shadow-xl"
        />
      </div>
      <div class="hidden lg:flex lg:flex-col gap-6 text-left order-3 w-auto lg:flex-1">
        <div class="flex items-center justify-start gap-2 flex-wrap">
          <span class="text-[30px] leading-none">🍔</span>
          <span class="title text-[30px] md:text-[36px] leading-tight text-dark">Livraison à</span>
          <span class="title text-[30px] md:text-[36px] text-primary leading-tight">Domicile</span>
        </div>
        <div class="flex flex-col gap-1">
          <p class="text text-[22px] font-600 text-dark">Pas envie de sortir ? On comprend.</p>
          <p class="text text-[22px] font-600 text-dark">Commandez, détendez-vous, et laissez-nous faire.</p>
          <p class="text text-[22px] font-600 text-dark">Votre repas arrive pendant que vous restez bien au chaud.</p>
        </div>
        <div class="flex items-center justify-start gap-4 p-4 rounded-xl border border-primary/10 bg-primary/5">
          <div class="flex justify-center items-center bg-primary text-white w-14 h-14 rounded-full flex-shrink-0 shadow-lg">
            <mat-icon>phone</mat-icon>
          </div>
          <div class="flex flex-col">
            <p class="text font-bold text-dark text-lg">Comment commander ?</p>
            @for (phone of phones(); track phone) {
            <div>
              <p class="text text-[24px] font-700 text-dark">Appelez :
                <a [href]="'tel:' + phone" class="text-primary hover:underline transition-all">{{ phone }}</a>
                </p>
              </div>
            }
          </div>
        </div>
      </div>

    </div>
  </div>

</div>
